import { useEffect, useRef } from 'react';
import { supabase } from '@/integrations/supabase/client';
import Papa from 'papaparse';

const ENRICHMENT_FLAG = 'ingredient_enrichment_v4_complete';

export function useIngredientEnrichment() {
  const hasRun = useRef(false);

  useEffect(() => {
    // Prevent double execution in dev mode
    if (hasRun.current) return;
    hasRun.current = true;

    // Check if already completed
    if (localStorage.getItem(ENRICHMENT_FLAG)) {
      console.log('[Ingredient Enrichment] Already completed, skipping');
      return;
    }

    const runEnrichment = async () => {
      try {
        console.log('[Ingredient Enrichment] Starting auto-import...');
        
        // Fetch CSV
        const response = await fetch('/data/facefable_ingredient_engine_v4_500_enriched.csv');
        if (!response.ok) {
          console.error('[Ingredient Enrichment] Failed to fetch CSV');
          return;
        }
        
        const csvText = await response.text();
        const { data } = Papa.parse(csvText, { header: true, skipEmptyLines: true });
        
        console.log(`[Ingredient Enrichment] Parsed ${data.length} rows, calling edge function...`);
        
        // Call edge function
        const { data: result, error } = await supabase.functions.invoke('import-ingredient-csv', {
          body: { csvData: data }
        });
        
        if (error) {
          console.error('[Ingredient Enrichment] Edge function error:', error);
          return;
        }
        
        console.log('[Ingredient Enrichment] Success:', result);
        
        // Mark as complete
        localStorage.setItem(ENRICHMENT_FLAG, new Date().toISOString());
        
      } catch (err) {
        console.error('[Ingredient Enrichment] Error:', err);
      }
    };

    // Run after a short delay to not block initial render
    setTimeout(runEnrichment, 2000);
  }, []);
}
